<template>
  <div
    class="example-drag-lot aling-center"
    style="position: fixed; bottom:5px; left: 30%;"
  >
    <b-row
      class="m-0"
      style="width: 100%;"
    >
      <b-col
        cols="12"
        class="header"
      >
        <b-row>
          <b-col
            cols="10"
            class="pr-0"
          >
            <h4
              style="color: red;"
              class="m-0"
            >
              Arquivos carregados não publicados ({{ arquivos.length }})
            </h4>
            <span>Arraste o arquivo no documento que deseja realizar a publicação </span>
          </b-col>
          <b-col
            cols="2"
            class="icons-header pl-0 pr-1"
          >
            <span
              v-b-tooltip
              :title="showList? 'Minimizar' : 'Maximizar'"
            >
              <font-awesome-icon
                :icon="showList? faChevronDown : faChevronUp"
                class="text-secondary mr-50"
                style="font-size:1.3rem !important;width:22px; color: red !important; margin-right: 10px; cursor: pointer;"
                @click="closeList"
              />
            </span>
            <span
              v-b-tooltip
              title="Remover todos"
            >
              <font-awesome-icon
                :icon="faTrash"
                class="text-secondary mr-50"
                style="font-size:1.3rem !important;width:22px; color: red !important; cursor: pointer;"
                @click="removerArquivosEmLoteDoServidor"
              />
            </span>
          </b-col>
        </b-row>

      </b-col>

      <b-col
        v-if="showList"
        cols="12"
        class="container-list"
      >
        <div>
          <div
            v-for="file in arquivos"
            :key="file.id"
            style="margin-bottom: 0.5rem; display: flex; justify-content: space-between;"
          >
            <div style="display: flex;">
              <font-awesome-icon
                :icon="icons(file.nomeArquivo)"
                class="text-secondary mr-50"
                style="font-size:1.3rem !important;width:22px; color: #c1af1d !important;"
              />
              <drag
                :data="file"
                :disabled="file.loading"
              >
                <p class="nome-arquivo">
                  {{ file.nomeArquivo }}
                </p>
              </drag>
            </div>
            <font-awesome-icon
              v-if="file.loading"
              :icon="faSpinner"
              class="text-secondary mr-50 icon-loading"
              style="font-size:1.3rem !important;width:22px; color: #c1af1d !important;"
            />
            <font-awesome-icon
              v-else
              :icon="faCheck"
              class="text-secondary mr-50"
              style="font-size:1.3rem !important;width:22px; color: #0f850f !important;"
            />

          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<style lang="scss">
.nome-arquivo {
  margin: 0 auto 0 0;
  font-weight: 600;
}

.aling-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.header {
  border-radius: 4px 4px 0 0;
  color: red;
  background-color: #ebebeb;
  padding: 10px;
}

.icons-header {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.container-list {
  width: 100%;
  max-height: 21rem;
  padding: 1rem 8px 1rem 8px;
  border-radius: 0 0 4px 4px;
  overflow: auto;
}

.example-drag-lot {
  background-color: #fff;
  width: 39vw;
  max-width: 39vw;
  box-shadow: 2px 2px 2px -2px rgba(0, 0, 0, 0.25);
}

.salvar-arquivo {
  width: auto !important;
}

.example-drag-lot label.btn {
  margin-bottom: 0;
  margin-right: 1rem;
}

.example-drag-lot .drop-active {
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  position: fixed;
  z-index: 9999;
  opacity: 0.6;
  text-align: center;
  background: #000;
}

.example-drag-lot .drop-active h3 {
  margin: -0.5em 0 0;
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  font-size: 40px;
  color: #fff;
  padding: 0;
}

.example-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 1rem;
}

.icon-loading{
  animation: rotate-animation 5s infinite linear;
}

@keyframes rotate-animation {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>

<script>
import { mapGetters } from 'vuex'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faFileAlt, faChevronDown, faChevronUp, faTrash, faFilePdf, faFileWord, faFileCsv, faFileArchive, faFileExcel, faFileImage, faCheck, faSpinner, faFile,
} from '@fortawesome/free-solid-svg-icons'
import { Drag } from 'vue-easy-dnd'

export default {
  components: {
    FontAwesomeIcon,
    Drag,
  },
  data() {
    return {
      faCheck,
      faSpinner,
      faTrash,
      faFile,
      faFileAlt,
      faChevronUp,
      faChevronDown,
      faFilePdf,
      faFileWord,
      faFileCsv,
      faFileArchive,
      faFileExcel,
      faFileImage,
      files: [],
      arquivo: '',
      showList: false,
    }
  },
  created() {
    this.showList = this.arquivos.length
  },
  computed: {
    ...mapGetters('empresaExGlobal', ['empresa']),
    ...mapGetters('uploadLote', ['arquivos']),
  },
  methods: {
    closeList() {
      this.showList = !this.showList
    },
    icons(nomeArquivo) {
      const tipoArquivo = nomeArquivo.split('.').pop()

      if (tipoArquivo.toUpperCase() === 'PDF') {
        return this.faFilePdf
      }
      if (tipoArquivo.toUpperCase() === 'PNG' || tipoArquivo.toUpperCase() === ' JPEG') {
        return this.faFileImage
      }
      if (tipoArquivo.toUpperCase() === 'EXCEL' || tipoArquivo.toUpperCase() === 'XLSX') {
        return this.faFileExcel
      }
      if (tipoArquivo.toUpperCase() === 'CSV') {
        return this.faFileCsv
      }
      if (tipoArquivo.toUpperCase() === 'DOCX') {
        return this.faFileWord
      }
      if (tipoArquivo.toUpperCase() === 'RAR' || tipoArquivo.toUpperCase() === 'ZIP') {
        return this.faFileArchive
      }
      if (tipoArquivo.toUpperCase() === 'TXT') {
        return this.faFileAlt
      }
      return this.faFile
    },
    removerArquivosEmLoteDoServidor() {
      this.$emit('removeArquivos')
    },
  },
}
</script>
